{
  "context_card": {
    "accounting_id": "Accounting ID:",
    "price_lists": {
      "title_company": "This company's price lists:",
      "title_section": "This section's price lists:",
      "empty_company": "This company has no price lists",
      "empty_section": "This section has no price lists"
    },
    "payment_on_account": {
      "title": "Payment on acccount",
      "balance": "Balance:",
      "credit_limit": "Credit limit:",
      "net_terms": {
        "title": "Net terms:",
        "7_days": "7 days",
        "15_days": "15 days",
        "30_days": "30 days",
        "45_days": "45 days",
        "60_days": "60 days",
        "90_days": "90 days"
      }
    },
    "sales_agent_groups": {
      "title_company": "This company's sales agent groups:",
      "title_section": "This section's sales agent groups:",
      "empty_company": "This company has no sales agent groups",
      "empty_section": "This section has no sales agent groups"
    }
  },
  "section_list": {
    "company_load_error": "Failed to load company information",
    "add_button": "Add section",
    "identifiers": {
      "sparklayer": "SparkLayer ID:",
      "external": "Platform ID:",
      "integration": "Integration ID:",
      "accounting": "Accounting ID:"
    },
    "company_users": {
      "title": "Company users",
      "email": "Email:",
      "role": "Role:"
    }
  },
  "section_tree": {
    "add_node_modal": {
      "title_section": "Add a new section:",
      "title_customer": "Attach a company user:",
      "switch_section": "Add section",
      "switch_customer": "Attach customer"
    },
    "add_company_user": "Add company user"
  },
  "add_company_user": {
    "error": "Failed to load customer",
    "description": "Search for a customer to assign to this section... I need to think of more things to fill this giant freaking space"
  },
  "role_label": {
    "description": "Assign a role for {customerName} in section {sectionName}:",
    "role_list_error": "Failed to fetch roles",
    "role_update_error": "Failed to assign role"
  }
}
